<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    title="发料记录"
    width="1200px"
    class="adaptationModal"
  >
    <el-table v-loading="loading" border stripe :data="tableData">
      <el-table-column type="index" align="center" width="55" label="#"></el-table-column>
      <el-table-column prop="materialNo" label="物料编号" width="110" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="materialName" label="物料名称" minWidth="300" show-overflow-tooltip></el-table-column>
      <el-table-column prop="warehouseNo" label="仓库编号" minWidth="80" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="warehouseName" label="仓库名称" minWidth="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="locationNo" label="仓位编号" minWidth="140" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="locationName" label="仓位名称" minWidth="80" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="quantity" label="发料数量" width="80" align="center"></el-table-column>
      <el-table-column prop="unitName" label="单位" width="70" align="center" show-overflow-tooltip></el-table-column>
    </el-table>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      loading: false,
    };
  },

  methods: {
    open(billNo) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.getRecords(billNo);
      });
    },

    // 根据派工单号查询发料记录
    getRecords(billNo) {
      this.loading = true;
      this.$http
        .get("basic", `outStockBills/workOrderIssue?relBillNo=${billNo}`)
        .then((res) => {
          if (res.success) {
            this.tableData = res.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
